import React from 'react'
import DemographyModals from './DemographyModals'
import OpportunityModals from './OpportunityModal'
import TestimoniModals from './TestimoniModals'

function ModalsContainer() {
  return (
    <React.Fragment>
      <TestimoniModals />
      <OpportunityModals />
      <DemographyModals />
    </React.Fragment>
  )
}

export default ModalsContainer